(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atv-trailer-arm"] && !Shopify.designMode) return;
  try {
    
// Interactive arm demo functionality
function initATVTrailerArm(sectionId) {
  const arm = document.getElementById(`demoArm-${sectionId}`);
  const buttons = document.querySelectorAll(`#atv-trailer-arm [data-terrain]`);
  
  function moveArm(terrain) {
    const joints = arm.querySelectorAll('.demo-joint');
    
    // Reset to default position
    arm.style.transform = 'rotate(0deg)';
    joints.forEach(joint => joint.style.backgroundColor = '#e63946');
    
    // Apply different transformations based on terrain
    switch(terrain) {
      case 'flat':
        arm.style.transform = 'rotate(0deg)';
        joints[0].style.backgroundColor = '#4CAF50';
        joints[1].style.backgroundColor = '#4CAF50';
        joints[2].style.backgroundColor = '#4CAF50';
        break;
      case 'hill':
        arm.style.transform = 'rotate(15deg)';
        joints[0].style.backgroundColor = '#FF9800';
        joints[1].style.backgroundColor = '#FF9800';
        joints[2].style.backgroundColor = '#FF9800';
        break;
      case 'rocky':
        arm.style.transform = 'rotate(-10deg) translateY(20px)';
        joints[0].style.backgroundColor = '#795548';
        joints[1].style.backgroundColor = '#795548';
        joints[2].style.backgroundColor = '#795548';
        break;
      case 'mud':
        arm.style.transform = 'rotate(5deg) translateY(10px)';
        joints[0].style.backgroundColor = '#8D6E63';
        joints[1].style.backgroundColor = '#8D6E63';
        joints[2].style.backgroundColor = '#8D6E63';
        break;
    }
  }
  
  // Add click event listeners to buttons
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const terrain = this.getAttribute('data-terrain');
      moveArm(terrain);
    });
  });
  
  // Initialize with flat terrain
  moveArm('flat');
}

// Initialize when section loads
document.addEventListener('DOMContentLoaded', function() {
  const sectionId = document.getElementById('atv-trailer-arm').getAttribute('data-section-id');
  initATVTrailerArm(sectionId);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
